import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('payments', app)
  return store
}
